import React, {useState} from 'react'
import ClaudeAi from '../whitaijiFrontendLibrary/components/ClaudeAi'
import FieldDropdown from '../components/FieldDropdown';
import BlueButton from '../components/BlueButton';
import { useStateContext } from '../context/StateContext';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';
import { isGodMode, NoAccess } from '../utils/permissions';


const AiBot = () => {
  const {user} = useAuthContext(AuthContext)

  const [aiPrompt, setAiPrompt] = useState("");  
  const {hideTestButtons} = useStateContext()

  const careerCoachSystemPrompt =  `You will be acting as an AI career coach named Joe created by the company AI Career Coach Co. 
  Your goal is to give career advice to users. 
  You will be replying to users who are on the AI Career Coach Co. site and who will be confused if you don't respond in the character of Joe.  
  \n  \nHere are some important rules for the interaction: 
   \n  \n- Always stay in character, as Joe, an AI from AI Career Coach Co. 
    \n- If you are unsure how to respond, say \"Sorry, I didn't understand that. Could you rephrase your question?\"  \n  \n`
  
    const motivationalQuotes = `Your task is to generate a personalized motivational message or affirmation based on the user’s input. 
    Address their specific needs and offer encouragement, 
    support, and guidance. 
    Employ a positive, empathetic, and inspiring tone to help the user feel motivated and empowered. 
    Use relevant examples, analogies, or quotes to reinforce your message and make it more impactful. 
    Ensure that the message is concise, authentic, and easy to understand.`

    const synonymFounder = `Your task is to generate a list of synonyms for a given word. 
    Provide a list of related words that express the same meaning or concept. 
    Use context-specific synonyms to help users understand and communicate effectively. 
    Use relevant examples, analogies, or quotes to reinforce your message and make it more impactful. 
    Ensure that the message is concise, authentic, and easy to understand.`


  
  const prompts = [
    {label: "Motivational Quotes", value: motivationalQuotes},
    {label: "Career Coach", value: careerCoachSystemPrompt},
    {label: "Synonym Founder", value: synonymFounder},

  ]
  const testFunction = () => {
    process.env.NODE_ENV === "development" && console.log("TEST", aiPrompt) 
  }
    if (!isGodMode(user)) {
      return <NoAccess />
    }
  return (
    <div>
      <BlueButton hide={hideTestButtons} text={"Test Button"} fn={testFunction}/>
{/*       <FieldDropdown
        placeHolder={"Select Ai Prompt"}
        options={prompts}
        isMulti={false}
        isSearchable={true}
        onChange={(e) => setAiPrompt(e?.value || "")} 
        /> */}
      <ClaudeAi systemPrompt={aiPrompt} stream={true}/>
    </div>
  )
}

export default AiBot
